import { AppState } from '../reducers';
import { createSelector } from 'reselect';

const selectFeedback = (state: AppState) => state.feedback;
export const getFeedback = createSelector(selectFeedback, feedback => feedback);
